import { defineStore, Pinia } from 'pinia'
import { isLocalStorageAvailable } from '~/utility/isLocalStorageAvailable'

export const useOnboardingStore = defineStore('onboardingStore', () => {
  const storageKey = 'onboardingStates'
  const onboardingStates = ref<Record<string, boolean>>({})
  const userDataStore = useUserDataStore(usePinia() as Pinia)

  function getOnboardingStates(): Record<string, boolean> {
    if (!isLocalStorageAvailable) {
      return {}
    }
    const storageObj = JSON.parse(localStorage.getItem(storageKey) || '{}')
    return storageObj
  }

  function setOnboardingState(key: string, value: boolean) {
    if (!isLocalStorageAvailable) {
      return
    }
    onboardingStates.value = { ...onboardingStates.value, [key]: value }
    localStorage.setItem(storageKey, JSON.stringify(onboardingStates.value))
  }

  function setFavouritesOnboardingState({
    shown,
    closed,
  }: {
    shown?: boolean
    closed?: boolean
  }) {
    if (
      shown !== undefined &&
      !!userDataStore.userSettings &&
      userDataStore.userSettings?.favourites_onboarding !== !shown
    ) {
      userDataStore.setUserSetting('favourites_onboarding', !shown)
    }
    if (closed !== undefined) {
      setOnboardingState('favouritesClosed', closed)
    }
  }

  const shouldShowFavouritesOnboarding = computed(() => {
    return (
      'favouritesClosed' in onboardingStates.value &&
      !onboardingStates.value.favouritesClosed &&
      (!('favourites_onboarding' in userDataStore.userSettings) ||
        userDataStore.userSettings?.favourites_onboarding === true)
    )
  })

  const handleStorageEvent = (event: StorageEvent) => {
    if (event.key === storageKey) {
      onboardingStates.value = getOnboardingStates()
    }
  }

  onMounted(() => {
    onboardingStates.value = getOnboardingStates()

    // Sync changes across browser tabs
    window.addEventListener('storage', handleStorageEvent)
  })

  onUnmounted(() => {
    if (window && window.removeEventListener && handleStorageEvent) {
      window.removeEventListener('storage', handleStorageEvent)
    }
  })

  return {
    setFavouritesOnboardingState,
    shouldShowFavouritesOnboarding,
  }
})
